module.exports = __webpack_public_path__ + "img/03-my-login.88f248e4.png";